export default __webpack_public_path__ + "static/media/404.5e1f7dbe.png";